import React, { useState, useEffect } from "react";
import Navbar from "./Navbar/Navbar";
import FeatureBox from "./Navbar/FeatureBox";
import Footer from "../../../Components/Content/Footer";
import dashboardImage from "../../../images/landing.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import Feature from "./Fatures/Feature";
const MainNavigation = () => {
  const [navState, setNav] = useState(false);
  useEffect(() => {
    const changeBackground = () => {
      if (window.scrollY >= 50) {
        setNav(true);
      } else {
        setNav(false);
      }
    };
    window.addEventListener("scroll", changeBackground);
    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);

  return (
    <div>
      <div id="main">
        <Navbar />
        <div className="d-flex align-items-center banner">
          <div className="col-md-6">
            <div className="name">
              <h1>
                <span>NGYELSO</span>
              </h1>
              <p>
                An{" "}
                <span style={{ color: "#2d7d9f", fontWeight: "bold" }}>
                  intuitive app
                </span>{" "}
                for managing office leave{" "}
                <span style={{ color: "#2d7d9f", fontWeight: "bold" }}>
                  requests
                </span>{" "}
                and{" "}
                <span style={{ color: "#2d7d9f", fontWeight: "bold" }}>
                  schedules
                </span>{" "}
              </p>
              <Link to="/login">
                <button className="buttonLogin pt-1">LOGIN</button>
              </Link>
            </div>
          </div>
          <div className="col-md-6 text-center">
            <img src={dashboardImage} alt="Dashboard" className="img-fluid" />
          </div>
        </div>
      </div>
      <div id="features">
        <h1 className="text-center abcd pb-5">
          <strong>WHY NGYELSO?</strong>
        </h1>
        <div
          className="row d-flex justify-content-between"
          style={{ width: "100%" }}
        >
          <div className="col-md-3">
            <FeatureBox
              icon="far fa-calendar-check"
              title="Simplify Leave Request"
              description="Effortlessly request and approve leave, saving time and reducing administrative hassle."
            />
          </div>
          <div className="col-md-3">
            <FeatureBox
              icon="fas fa-chart-line"
              title="Enhance Productivity"
              description="Improve workplace efficiency with automated workflows and resource allocation."
            />
          </div>
          <div className="col-md-3">
            <FeatureBox
              icon="far fa-heart"
              title="Promote Work-Life Balance"
              description="Support your team's well-being, ensuring a healthier work-life balance."
            />
          </div>
        </div>
      </div>
      {/* <Feature /> */}
      <Footer />
    </div>
  );
};

export { MainNavigation };
